import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CheckoutForm from "./CheckoutForm";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import BackButton from "../../../main/BackButton";
import "./css/CheckoutForm.module.css";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE);

const appearance = {
  base: {
    color: "#32325d",
  },
};

const elFonts = [
  {
    cssSrc:
      "https://fonts.googleapis.com/css2?family=Encode+Sans+Condensed:wght@100&display=swap",
    family: "Encode Sans Condensed, sans-serif",
    style: "normal",
  },
];

const Purchase = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  // All hooks must be called before any conditional returns
  const [success, setSuccess] = useState(false);

  // Get state values safely
  const state = location.state || {};
  const productId = state.product;
  const typeId = state.type;

  useEffect(() => {
    // Redirect if no state
    if (!location.state) {
      navigate('/');
      return;
    }

    if (success) {
      navigate("/products/success");
    }
  }, [success, navigate, location.state]);

  // Early return if no state
  if (!location.state) {
    return null;
  }

  return (
    <div style={{ height: "100%" }}>
      <BackButton />
      <Elements
        style={appearance}
        stripe={stripePromise}
        options={{ fonts: elFonts }}
      >
        <CheckoutForm
          productId={productId}
          typeId={typeId}
          setSuccess={setSuccess}
        />
      </Elements>
    </div>
  );
};

export default Purchase;
